import * as bootstrap from 'bootstrap';

export default class SiteHeader extends HTMLElement {

    constructor() {
        super()

        console.log("SiteHeader.js")

        this.backdrop = this.querySelector('.backdrop')
        this.mainNavOpened = false
        this.mainNav = this.querySelector('.main-nav')
        this.searchPanelOpened = false
        this.searchPanel = this.querySelector('.search-panel')
        this.searchPanelKeywordOpened = false
        this.searchPanelKeyword = this.querySelector('.search-panel-keyword')
        this.toggleSearchPanelLinks = document.querySelectorAll('[data-toggle="search-panel"]')
        this.toggleSearchPanelKeywordLinks = document.querySelectorAll('[data-toggle="search-panel-keyword"]')
        this.toggleMainNavLinks = document.querySelectorAll('[data-toggle="main-nav"]')
        this.headerOffset = null
        this.updateHeaderOffsetRequested = false
    }

    connectedCallback() {

        this.toggleMainNavLinks.forEach(toggleMainNavLink => {
            toggleMainNavLink.addEventListener('click', (e) => {
                e.preventDefault()
                if (this.mainNavOpened) {
                    this.closeMainNav()
                } else {
                    this.openMainNav()
                }
            })
        })

        this.toggleSearchPanelLinks.forEach(toggleSearchPanelLink => {
            toggleSearchPanelLink.addEventListener('click', (e) => {
                e.preventDefault()
                if (this.searchPanelOpened) {
                    this.closeSearchPanel()
                } else {
                    this.openSearchPanel()
                    // If target tab is requested
                    if (e.target.dataset.targetTab) {
                       const tab = document.querySelector(e.target.dataset.targetTab)
                        if (tab && bootstrap.Tab.getInstance(tab)) {
                            bootstrap.Tab.getInstance(tab).show()
                        }
                    }
                }
            })
        })

        this.toggleSearchPanelKeywordLinks.forEach(toggleSearchPanelKeywordLink => {
            toggleSearchPanelKeywordLink.addEventListener('click', (e) => {
                e.preventDefault()
                if (this.searchPanelKeywordOpened) {
                    this.closeSearchPanelKeyword()
                } else {
                    this.openSearchPanelKeyword()
                }
            })
        })

        this.updateHeaderOffset()

        this.requestHeaderOffsetUpdate = () => {
            if (this.updateHeaderOffsetRequested) {
                return
            }
            this.updateHeaderOffsetRequested = true
            window.requestAnimationFrame(() => {
                this.updateHeaderOffsetRequested = false
                this.updateHeaderOffset()
            })
        }

        window.addEventListener('scroll', this.requestHeaderOffsetUpdate, { passive: true })
        window.addEventListener('resize', this.requestHeaderOffsetUpdate)

        this.backdrop.addEventListener('click', (e) => {
            if (this.mainNavOpened) {
                this.closeMainNav('close')
            }
            if (this.searchPanelOpened) {
                this.closeSearchPanel('close')
            }
            if (this.searchPanelKeywordOpened) {
                this.closeSearchPanelKeyword('close')
            }
        })

    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.requestHeaderOffsetUpdate)
        window.removeEventListener('resize', this.requestHeaderOffsetUpdate)
    }

    // Le header est sticky mais la topbar qui le precede ne l'est pas : tant qu'elle
    // est visible, le header n'est pas colle au haut du viewport. Les panneaux fixes
    // (nav, recherche, backdrop) se positionnent donc via --header-offset.
    updateHeaderOffset() {
        const offset = Math.max(0, Math.round(this.getBoundingClientRect().top))
        if (offset === this.headerOffset) {
            return
        }
        this.headerOffset = offset
        this.style.setProperty('--header-offset', `${offset}px`)
    }

    openMainNav() {
        if (this.searchPanelOpened) {
            this.closeSearchPanel()
        }
        if (this.searchPanelKeywordOpened) {
            this.closeSearchPanelKeyword()
        }
        this.mainNav.classList.add('opened')
        this.mainNavOpened = true

        this.toggleMainNavLinks.forEach(toggleMainNavLink => {
            toggleMainNavLink.classList.add('active')
        })

        this.toggleBackdrop()
    }

    closeMainNav() {
        this.mainNav.classList.remove('opened')
        this.mainNavOpened = false

        this.toggleMainNavLinks.forEach(toggleMainNavLink => {
            toggleMainNavLink.classList.remove('active')
        })

        this.toggleBackdrop()
    }

    openSearchPanel() {
        if (this.mainNavOpened) {
            this.closeMainNav()
        }
        if (this.searchPanelKeywordOpened) {
            this.closeSearchPanelKeyword()
        }
        this.searchPanel.classList.add('opened')
        this.searchPanelOpened = true
        this.toggleBackdrop()
    }

    closeSearchPanel() {
        this.searchPanel.classList.remove('opened')
        this.searchPanelOpened = false
        this.toggleBackdrop()
    }

    openSearchPanelKeyword() {
        console.log("ouvre panel keyword")
        if (this.mainNavOpened) {
            this.closeMainNav()
        }
        if (this.searchPanelOpened) {
            this.closeSearchPanel()
        }
        this.searchPanelKeyword.classList.add('opened')
        this.searchPanelKeywordOpened = true
        this.toggleBackdrop()
    }

    closeSearchPanelKeyword() {
        console.log("ferme panel keyword")
        this.searchPanelKeyword.classList.remove('opened')
        this.searchPanelKeywordOpened = false
        this.toggleBackdrop()
    }

    toggleBackdrop() {
        if (this.mainNavOpened || this.searchPanelOpened || this.searchPanelKeywordOpened) {
            this.backdrop.classList.add('show')
        } else {
            this.backdrop.classList.remove('show')
        }
    }

}